<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-9 col-lg-5 col-xl-5 my-1">
          <div class="card p-3">
            <!-- Logo -->
            <div class="login-logo">
              <router-link to="/">
                <img
                  src="@/assets/img/UK-DION-LOGISTICS-LOGO-01.png"
                  alt=""
                  class="text-center"
                  style="width:100px;"
                  v-if="brand == 'DION LOGISTICS'"
                />
                <img src="@/assets/img/logo.png" class="text-center" v-else />
              </router-link>
            </div>

            <div class="login-box-body" v-if="!showOtp">
              <!-- Heading -->
              <!--<h1 class="display-4 text-center login-box-message--1 mb-1">Hi, welcome back</h1>-->
              <!-- Subheading -->
              <p class="text-center login-box-message--2 mb-3">
                Welcome! Login to your account
              </p>
              <!-- Form -->
              <form @submit.prevent="login">
                <!-- Email -->
                <div class="form-group">
                  <label for="email">Email Address or Username</label>
                  <input
                    type="text"
                    id="email"
                    class="form-control"
                    v-model.trim="email"
                    name="email"
                  />
                </div>
                <!-- Password -->
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label for="passsword">Password</label>
                    </div>
                    <div class="col-auto">
                      <!--<router-link to="/" class="form-text small" style="color: #95aac9;">
                                                Forgot password?
                                            </router-link>-->
                    </div>
                  </div>
                  <!-- Input group -->
                  <div class="input-group input-group-merge">
                    <input
                      :type="passwordFieldType"
                      id="passsword"
                      name="passsword"
                      v-model.trim="password"
                      class="form-control form-control-appended"
                      placeholder="Enter your password"
                    />
                    <!-- Icon -->
                    <div
                      class="input-group-append"
                      @click="switchVisibility"
                      style="cursor: pointer;"
                    >
                      <span class="input-group-text custom-input-group-text">
                        <i :class="appendEyeIconType"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Button -->
                <button
                  class="button text-uppercase btn-lg btn-block mb-2"
                  :disabled="!formIsValid || loading"
                >
                  <span class="custom-loader" v-if="loading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Logging in...</span
                    >
                  </span>
                  <span v-else>
                    Login
                  </span>
                </button>
                <!-- Link -->
                <!-- <div class="text-center">
                                    <p class="text-muted text-center">
                                        Don't have an account yet? <router-link :to="{name: ''}" style="color: #1e9ff2;">Create Account</router-link>.
                                    </p>
                                </div> -->
              </form>
            </div>
            <div class="login-box-body" v-if="showOtp && userResData !== null">
              <!-- Heading -->
              <!--<h1 class="display-4 text-center login-box-message--1 mb-1">Hi, welcome back</h1>-->
              <!-- Subheading -->
              <p class="text-center login-box-message--2 mb-3">
                Enter Login PIN
              </p>
              <!-- Form -->
              <form @submit.prevent="verifyOtp">
                <!-- Email -->
                <!-- <div class="form-group">
                  <label for="phone_number">Phone Number</label>
                  <input
                    type="text"
                    id="phone_number"
                    class="form-control"
                    v-model.trim="userResData.phone_number"
                    name="phone_number"
                  />
                </div> -->
                <!-- Password -->
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label for="otp">PIN</label>
                    </div>
                    <div class="col-auto">
                      <!--<router-link to="/" class="form-text small" style="color: #95aac9;">
                                                Forgot password?
                                            </router-link>-->
                    </div>
                  </div>
                  <!-- Input group -->
                  <div class="input-group input-group-merge">
                    <input
                      type="text"
                      id="otp"
                      class="form-control"
                      placeholder="Enter your PIN"
                      v-model.trim="otp"
                      name="otp"
                    />
                  </div>
                </div>
                <!-- Button -->
                <button
                  class="button text-uppercase btn-lg btn-block mb-2"
                  :disabled="!otpFormIsValid || otpLoading"
                >
                  <span class="custom-loader" v-if="otpLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>
                    Verify PIN
                  </span>
                </button>
                <!-- Link -->
                <!-- <div class="text-center">
                                    <p class="text-muted text-center">
                                        Don't have an account yet? <router-link :to="{name: ''}" style="color: #1e9ff2;">Create Account</router-link>.
                                    </p>
                                </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TokenService } from "../../services/storage.service";
import { prefetchPublicKey } from "../../services/credentialEncryption";
export default {
  name: "Login",
  created() {
    prefetchPublicKey();
  },
  data() {
    return {
      passwordFieldType: "password",
      appendEyeIconType: "feather-eye",
      email: "",
      password: "",
      brand: "",
      otp: "",
      userResData: null,
      deviceToken : null
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    otpLoading() {
      return this.$store.getters.otpLoading;
    },
    formIsValid() {
      return this.email !== "" && this.password !== "";
    },
    otpFormIsValid() {
      return this.otp !== "";
    },
    ...mapGetters(["userObj"]),
    showOtp() {
      return this.$store.getters.showOtp;
    }
  },
  methods: {
    generateRandomString(){
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 40; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.appendEyeIconType =
        this.appendEyeIconType === "feather-eye"
          ? "feather-eye-off"
          : "feather-eye";
    },
    async login() {
      this.deviceToken = TokenService.getDeviceToken() || this.generateRandomString();
      let data = {
        email: this.email,
        password: this.password,
        device_token : this.deviceToken
      };
      try {
        const response = await this.$store.dispatch("loginUser", data);
        // console.log(response);

        if (response.status === 200) {
          // remove reauthDeadline
          localStorage.removeItem("reauthDeadline");
          this.userResData = response.data.data;
          this.$store.commit("setOtpStatus", true);
        }
        // console.log(this.userResData);
      } catch (error) {
        // console.log(error);
      }
    },
    verifyOtp() {
      try {
        let data = {
          phone_number: this.userResData.phone_number,
          expoxifier : this.userResData.e_lantro,
          otp: this.otp,
          device_token : this.deviceToken
        };
        this.$store.dispatch("verifyOtp", data);
      } catch (error) {
        // console.log(error);
      }
    }
  },
  mounted() {
    $("body").css("background", "#3d4f86");
    this.brand = "Capital Bank ADMIN";
  }
};
</script>

<style>
.login-logo,
.register-logo {
  font-size: 35px;
  text-align: center;
  margin-bottom: 25px;
}

.login-box-message--1 {
  font-size: 40px;
  font-weight: 700;
  font-style: normal;
  color: #001833;
  line-height: 51.64px;
}

.login-box-message--2 {
  font-size: 25px;
  font-weight: 600;
  font-style: normal;
  color: #a2b3ca;
  line-height: 31.98px;
}

.input-group.input-group-merge > .form-control-appended {
  padding-right: 0.375rem;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-width: 0;
}

.input-group.input-group-merge > .input-group-append > .input-group-text {
  padding-left: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  border-left-width: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-input-group-text {
  padding: 0.5rem 0.75rem;
  color: #95aac9;
  background-color: #fff;
}

.input-group.input-group-merge
  > .form-control:focus
  ~ [class*="input-group"]
  > .input-group-text {
  background-color: #fff;
  border-color: #1e9ff2;
  outline: 0;
  box-shadow: none;
}
</style>
